app.service('agreementsSubmit', function (log, agreementsRemoveModal, account, front, message, modal, nativeApp) {
	var valuesBeforePost;
	var valuesOnPost;
	var $initForm;
	var $attConsentInput;
	var analyticsConsentAllowed;


	function changedAgreements() {
		return valuesOnPost.filter(function (element, i) {
			return valuesBeforePost[i].value != element.value;
		}).map(function (element, i) {
			var value = valuesBeforePost.filter(function (e) {
				return element.name == e.name;
			})[0].value;
			if (element.name == 'PERMISSION_TO_ELECTRONIC_CHANNEL' && element.value == false) {
				localStorage.setItem('permissions-minimalize', true);
			}
			return element.name + ": " + value + ' => ' + element.value;
		}).join(", ");
	}
	function allAgreements() {
		return valuesOnPost.map(function (element, i) {
			return element.name + ': ' + element.value
		}).join(", ");
	}

	function setNativeAppEvents() {
		// zgody analityczne dla aplikacji mobilnej
		$attConsentInput = $inputs.filter('[data-types*="ATT_CONSENT"]');
		if (!$attConsentInput.length) {
			return;
		}
		
		if (window.mobileApp) { // bez nakładania eventów lokalnie, bo nie ma dostępnej aplikacji mobilnej
			$initForm.addClass('loading');
			// nasłuchiwanie statusu ANALYTICS_CONSENT_AVAILABLE przed zapisaniem formularza
			nativeApp.setEventListener(function (eventDetail) {
				if (eventDetail?.type === 'ANALYTICS_CONSENT_AVAILABLE') {
					analyticsConsentAllowed = eventDetail.allowed;
					$attConsentInput.prop('checked', analyticsConsentAllowed === true);
					$initForm.removeClass('loading');
				}
			});
			nativeApp.postMessage({ type: 'ANALYTICS_CONSUMER_READY' });
		}
		
		// dodanie GA dla rozwijania i zwijania zgody ATT_CONSENT
		const $mobileAppAnalyticsCheckbox = $attConsentInput.closest('.checkbox-css');
		const $mobileAppAnalyticsMoreLinks = $mobileAppAnalyticsCheckbox.find('a');
		if ($mobileAppAnalyticsMoreLinks.length) {
			$mobileAppAnalyticsMoreLinks.on('click', function () {
				// kliknięcia linków zwiń / rozwiń
				const $paragraphText = $(this).closest('p');
				let buttonText = '';
				let buttonDetails = '';
				if ($paragraphText.length && $paragraphText.hasClass('less')) {
					buttonText = $mobileAppAnalyticsMoreLinks.filter('.more').text();
					buttonDetails = 'show';
				} else if ($paragraphText.length && $paragraphText.hasClass('more')){
					buttonText = $mobileAppAnalyticsMoreLinks.filter('.less').text();
					buttonDetails = 'hide';
				}
				UA.push({
					'event': 'button_click',
					'button_name': 'att_consent',
					'button_text': buttonText,
					'button_details': buttonDetails
				});
			});
		}

		if (front.isIOS()) { // Sprawdzenie, czy użytkownik korzysta z systemu iOS na aplikacji mobilnej
			$attConsentInput.on('click', function () {
				$attConsentInput.prop('checked', !$(this).is(':checked'));
				message.get('aplikacja mobilna - zgoda na analityke - komunikat dla iOS').then(function (html) {
					modal.alert(html);
				})
			});
		}
	}

	function submitAgreementsForm() {
		valuesOnPost = agreementStatus();
		
		// sprawdzenie zaznaczenia zgody ATT_CONSENT przed wysłaniem formularza
		const attConsent = valuesOnPost.filter(function (element) {
			return element.name == 'ATT_CONSENT';
		})[0]?.value;
		// wysłanie statusu ATT_CONSENT w momencie zapisu formularza
		nativeApp.postMessage({ type: 'ANALYTICS_CONSENT_SET', allowed: attConsent });

		const internalMarketingConsent = valuesOnPost.filter(function (element) {
			return element.name.includes('PERMISSION_TO_PROCESSING');
		})[0]?.value;
		UA.push({
			'event': 'form_submit',
			'form_id': 'kme_formal_consents_form',
			'form_name': 'KME - Formularz zgód formalnych',
			'form_details': {
				'internal_marketing_consent': internalMarketingConsent,
				'att_consent': attConsent
			} 
		});

		log.event({
			'id': 'agreements-form',
			'f03': document.location.pathname,
			'f04': JSON.stringify(valuesOnPost) != JSON.stringify(valuesBeforePost),
			'f05': changedAgreements(),
			'f06': allAgreements(),
			// 'f07': '', // id zalogowanego użytkownika zbierane w log.js
			// 'f08': '', // email zalogowanego użytkownika zbierane w log.js
			'f09': getFormEmail(), // email z formularza
			'f10': getFormName() // identyfikator lub nazwa formularza
		});
	}
	function getFormName() {
		return $initForm.attr('action') || $initForm.attr('id');
	}
	function getFormEmail() {
		return $initForm.find('input[type="email"]') ? $initForm.find('input[type="email"]').val() : '';
	}

	function agreementStatus() {
		var result = [];
		$inputs.each(function () {
			const $element = $(this);
			const data = ($element.data('types') || "").split('|');
			const checked = $element.prop('checked');
			data.forEach(function (type) {
				result.push({
					'name': type,
					'value': checked
				});
			});
		});
		return result;
	}


	function init($form, $checkboxes) {
		if ($checkboxes && $form && $checkboxes.length && $form.length) {
			$inputs = $checkboxes;
			$initForm = $form;

			setNativeAppEvents();

			valuesBeforePost = agreementStatus();
			$form.submit(function () {
				if ($form.valid()) {
					submitAgreementsForm();
				}
			});

			agreementsRemoveModal.init($inputs.filter('[data-types*="PERMISSION_TO_ELECTRONIC_CHANNEL"]'));
		}
	}

	return {
		init, send: submitAgreementsForm
	}
});
